import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { todayNodeName } from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { IsToday } from "source/app/services/Time/Time";
import { DeleteMultipleNodesAsync } from "source/app/services/Workflows/ChangeData/DeleteNodesAsync";
import { LocalDeleteMultipleNodesForOutdatedTasks } from "./LocalDeleteMultipleNodesForOutdatedTasks";

export function DisplayRemoveOutdatedTasksLink({
    rootNode,
    childNodes,
}: {
    rootNode: IWorkflowNode;
    childNodes: IWorkflowNode[];
}) {
    if (rootNode.name !== todayNodeName) {
        return null;
    }

    const todayNode = rootNode;

    // childNodes are loaded separately (asynchronously) from rootNode
    const todayChildNodes = childNodes.filter(
        (node) => node.parentid === todayNode.id
    );

    if (todayChildNodes.length === 0) {
        return null;
    }

    const nodesToDelete = todayChildNodes.filter(
        (node) => !IsToday(node.lastmodifiedtime)
    );

    if (nodesToDelete.length === 0) {
        return null;
    }

    const styleClass = StyleClass(`displayRemoveOldTasksLink`, {
        padding: "10px",
        background: "hsla(0, 100%, 50%, 0.2)",
        borderRadius: "3px",
        margin: "5px",
    });

    return (
        <div className={styleClass}>
            Remove outdated tasks?{" "}
            <IconWithText
                iconSuffix={EGlyphicon.ok}
                displayAsBlock={false}
                whenClicked={async () =>
                    WithAnimatedProgressBarAsync(async () => {
                        LocalDeleteMultipleNodesForOutdatedTasks(nodesToDelete);
                        await DeleteMultipleNodesAsync(nodesToDelete);
                    }, `DisplayRemoveOutdatedTasksLink`)
                }
            >
                yes
            </IconWithText>
        </div>
    );
}
